import { Cover } from "components/Cover"
import { Input, Textarea } from "components/Form"
import { PortalControl } from "components/Portal/PortalControl"
import { useCallback, useMemo, useRef, useState } from "react"

type Props = {
	value: string
	onChange(value: string): void
	onBlur(): void
	loading: boolean
}

export const TextareaEditableCell = ({ value, onChange, onBlur, loading }: Props) => {
	const ref = useRef(null);
	const [focus, setFocus] = useState(false);

	const onFocusCallback = useCallback(
		() => {
			setFocus(true);
		},
		[]
	)

	const onBlurCallback = useCallback(
		() => {
			setFocus(false);
			onBlur();
		},
		[onBlur]
	)

	const control = useMemo(
		() => {
			if (focus) {
				return (
					<>
						<Cover onClick={onBlurCallback}/>
						<PortalControl containerRef={ref}>
							<Textarea
								value={value}
								onChange={onChange}
								onBlur={onBlurCallback}
								hideMaxLength
								focus
							/>
						</PortalControl>
					</>
				)
			}

			return (
				<Input
					value={value}
					onFocus={onFocusCallback}
					loading={loading}
					hideMaxLength
					size='small'
				/>
			)
		},
		[focus, loading, onBlurCallback, onChange, onFocusCallback, value]
	)

	return (
		<div ref={ref} style={{ width: '100%', height: '100%' }}>
			{control}
		</div>
	)
}
